<div class="mi6-mall">
  <div class="poker-mall-popup">
    <div class="pmp-dim" style="position: fixed;"></div>
    {{#if (equal resultText 'membership-required')}}
    <div class="pkm-popup pkm-popup--normal" style="width: 460px; margin-left: -230px;">
      <div class="pmp-header">
        <h3>포커 클래스 전용 머니 받기</h3>
      </div>
      <div class="pmp-body">
        <div class="pmp-message">
          <p>
            포커 클래스 고객님께 제공되는 서비스입니다.<br>
            지금 바로 신청하시고, 전용 머니 혜택을 받으세요!<br>
            <span>※ 포커 클래스를 이용하시면 매월 1회 클래스 전용 머니를 제공해드립니다.</span>
          </p>
        </div>
        <div class="pmp-btns">
          <a href="#" data-class-money-click="openMallClass" class="pmp-btn pmp-btn--buy"><span>포커 클래스 구경가기</span></a>
          <a href="#" data-class-money-click="confirm" class="pmp-btn pmp-btn--confirms"><span>확인</span></a>
        </div>
      </div>
    </div>
    {{/if}}

    {{#if (equal resultText 'can-receive')}}
    <div class="pkm-popup pkm-popup--normal">
      <div class="pmp-header">
        <h3>포커 클래스 전용 머니 받기</h3>
      </div>
      <div class="pmp-body">
        <p class="pmp-success">
          클래스 전용 머니를 받으실 수 있습니다.
        </p>
        <div class="item-name">
          {{{numberToShortTextTags classMoneyValue}}}
        </div>
        <p class="sub-info">
          클래스 전용 머니는 매월 1회 받으실 수 있으며 <br />
          수령하지 않은 전용 머니는 클래스 만료일에 선물함으로 지급됩니다.
        </p>
        <div class="pmp-btns">
          <a href="#" data-class-money-click="claim" class="pmp-btn pmp-btn--smalltxt"><span>전용 머니 받기</span></a>
          <a href="#" data-class-money-click="confirm" class="pmp-btn pmp-btn--cancel"><span>닫기</span></a>
        </div>
      </div>
    </div>
    {{/if}}

    {{#if (equal resultText 'already-done')}}
    <div class="pkm-popup pkm-popup--normal">
      <div class="pmp-header">
        <h3>포커 클래스 전용 머니 받기</h3>
      </div>
      <div class="pmp-body">
        <div class="pmp-message">
          <p>
            클래스 전용 머니를<br> 모두 받았습니다.
          </p>
        </div>
        <div class="pmp-btns">
          <a href="#" data-class-money-click="openMallGold" class="pmp-btn pmp-btn--buy"><span>전용 상품 구경하기</span></a>
          <a href="#" data-class-money-click="confirm" class="pmp-btn pmp-btn--confirms"><span>확인</span></a>
        </div>
      </div>
    </div>
    {{/if}}

    {{#if (equal resultText 'not-allowed')}}
    <div class="pkm-popup pkm-popup--normal">
      <div class="pmp-header">
        <h3>포커 클래스 전용 머니 받기</h3>
      </div>
      <div class="pmp-body">
        <div class="pmp-message">
          <p>
            클래스 전용 머니를<br> 모두 받았습니다.
          </p>
        </div>
        <div class="pmp-btns">
          <a href="#" data-class-money-click="openMallGold" class="pmp-btn pmp-btn--buy"><span>전용 상품 구경하기</span></a>
          <a href="#" data-class-money-click="confirm" class="pmp-btn pmp-btn--confirms"><span>확인</span></a>
        </div>
      </div>
    </div>
    {{/if}}

    {{#if (equal resultText 'success')}}
    <div class="pkm-popup pkm-popup--normal">
      <div class="pmp-header">
        <h3>포커 클래스 전용 머니 받기</h3>
      </div>
      <div class="pmp-body">
        <p class="pmp-success">
          클래스 전용 머니를 받았습니다.
        </p>
        <div class="item-name">
          {{{numberToShortTextTags expectedClassMoney}}}
        </div>
        <div class="pmp-btns">
          <a href="#" data-class-money-click="confirm" class="pmp-btn pmp-btn--confirms"><span>확인</span></a>
        </div>
      </div>
    </div>
    {{/if}}

    {{#if (equal resultText 'fail')}}
    <div class="pkm-popup pkm-popup--normal">
      <div class="pmp-header">
        <h3>포커 클래스 전용 머니 받기</h3>
      </div>
      <div class="pmp-body">
        <p class="pmp-success">
          죄송합니다. 에러가 발생했습니다.
        </p>
        <div class="pmp-btns">
          <a href="#" data-class-money-click="confirm" class="pmp-btn pmp-btn--confirms"><span>확인</span></a>
        </div>
      </div>
    </div>
    {{/if}}
  </div>
</div>